import { Component, effect, inject, input, InputSignal } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DATE_FORMAT,
  EStatusChipType,
  IOrderEvent,
  IParsedBooking,
  TIME_FORMAT,
} from '@web/dtos';
import { TableComponent } from '../table/table.component';
import { AppendTestIdPipe } from '../../../pipes/append-test-id/append-test-id.pipe';
import { TableCellComponent } from '../table/table-cell/table-cell.component';
import { TableHeaderComponent } from '../table/table-header/table-header.component';
import { CmsTextProviderService } from '../../../services/cms-text-provider.service';
import { DecimalsToCentsPipe } from '../../../pipes/decimals-to-cents/decimals-to-cents.pipe';
import { CentsToEurosPipe } from '../../../pipes/cents-to-euros/cents-to-euros.pipe';
import { OrderStatusChipComponent } from '../order-status-chip/order-status-chip.component';

@Component({
  selector: 'aw-bookings-overview',
  imports: [
    CommonModule,
    TableComponent,
    AppendTestIdPipe,
    TableCellComponent,
    TableHeaderComponent,
    DecimalsToCentsPipe,
    CentsToEurosPipe,
    OrderStatusChipComponent,
  ],
  templateUrl: './bookings-overview.component.html',
  styles: '',
})
export class BookingsOverviewComponent {
  public readonly id: InputSignal<string> = input.required();
  public readonly bookings: InputSignal<IParsedBooking[]> = input.required();
  public readonly events: InputSignal<IOrderEvent[]> = input.required();
  protected readonly cmsTextProvider: CmsTextProviderService = inject(
    CmsTextProviderService
  );
  protected readonly bookingRowKey = (row: IParsedBooking): string => row.id;

  protected readonly DATE_FORMAT: string = DATE_FORMAT;
  protected readonly TIME_FORMAT: string = TIME_FORMAT;

  protected readonly EStatusChipType: typeof EStatusChipType = EStatusChipType;

  protected readonly openDetails: Record<string, boolean> = {};

  constructor() {
    effect(() => {
      this.bookings().forEach((ticket: IParsedBooking): void => {
        this.openDetails[ticket.id] = false;
      });
    });
  }

  protected toggleDetails(orderId: string): void {
    this.openDetails[orderId] = !this.openDetails[orderId];
  }
}
